import styled from 'styled-components';

export const MainContainer = styled.main`
  padding-left: 250px;
  width: 100%;
`;

export const ContentContainer = styled.div`
  width: 100%;
  padding: 1rem;
`;

export const Title = styled.h1`
  font-size: 1.75rem;

  color: #282828;

  margin-bottom: 1rem;
`;